"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var style_1 = require("@lyearn/style");
function SvgLinkedIn(_props, svgRef) {
    var props = (0, style_1.useSvg)(_props);
    return (React.createElement("svg", tslib_1.__assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M3 9h4v11H3z" }),
        React.createElement("circle", { cx: 5, cy: 5, r: 2 }),
        React.createElement("path", { d: "M16.5 8.25A4.473 4.473 0 0013 9.953V9H9v11h4v-7a2 2 0 014 0v7h4v-7.25a4.5 4.5 0 00-4.5-4.5z" })));
}
exports["default"] = React.forwardRef(SvgLinkedIn);
//# sourceMappingURL=LinkedIn.js.map